












































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import AddSupplierQuotaModal from "./modals/addSupplierQuotaModal.vue";
import moment from "moment";
@Component({
  components: { AddSupplierQuotaModal },
})
export default class FlightControl extends Vue {
  isOpenModal: boolean = false;
  mockDataApprovedPassenger: any[] = [];
  headersApprovedPassenger: any[] = [];
  mockDataUnapprovedPassenger: any[] = [];
  headersUnapprovedPassenger: any[] = [];
  mockDataFlightSupplier: any[] = [];
  headersFlightSupplier: any[] = [];
  departureDate: Date = null;
  arrivalDate: Date = null;
  breadcrumbsItems: any[] = [];
  checkbox: boolean = false;
  items: any[] = [];
  active_tab: number = 0;
  selected: any[] = [];

  startDate: Date = null;
  startDateMenu: boolean = false;

  endDate: Date = null;
  endDateMenu: boolean = false;

  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }

  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  created() {
    (this.headersApprovedPassenger = [
      { text: "PNR", value: "pnr" },
      { text: "İsim Soyisim", value: "name" },
      { text: "Tedarikçi PNR", value: "supplierPnr" },
      { text: "Onaylanma Tarihi", value: "approvalDate" },
      { text: "Onaylanmış Fiyat", value: "approvedPrice" },
      { text: "Tedarikçi", value: "supplier" },
    ]),
      (this.mockDataApprovedPassenger = [
        {
          pnr: "xxx",
          name: "xxx",
          supplierPnr: "rrr",
          approvalDate: "08-06-2021",
          approvedPrice: "00,00",
          supplier: "10",
        },
      ]),
      (this.headersUnapprovedPassenger = [
        { text: "PNR", value: "pnr" },
        { text: "İsim Soyisim", value: "name" },
        { text: "Kota Tedarikçi", value: "supplierQuota" },
      ]),
      (this.mockDataUnapprovedPassenger = [
        {
          pnr: "xxx",
          name: "yyy",
          supplierQuota: "www",
        },
      ]),
      (this.headersFlightSupplier = [
        { text: "Şirket", value: "company" },
        { text: "Masraf", value: "cost" },
        { text: "Para Birimi", value: "currency" },
        { text: "Kota", value: "quota" },
        { text: "Onaylanmış Sayı", value: "approvedNumber" },
        { text: "PNR", value: "pnr" },
      ]),
      (this.mockDataFlightSupplier = [
        {
          company: "xxx",
          cost: "20",
          currency: "USD",
          quota: "2",
          approvedNumber: "5",
          pnr: "Za23234234m",
        },
      ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Kontrol", disabled: true },
      ]);

    this.items = [
      {
        id: 1,
        name: "Antalya",
        children: [{ id: 2, name: "AYT - ALA" }],
      },
    ];
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  data() {
    return {
      page: 1,
      range: [0, 70],

      companiesItems: ["REDWİNGS", "WİNDROSE", "PEGAS FLY"],
      companies: [],

      providersItems: ["CHARTERSCANNERS", "EMİN SARI"],
      providers: [],

      aircraftItems: ["Airbus(A380)", "Boeing (B 737-400)"],
      aircrafts: [],

      currencyItems: ["EUR", "RUB", "TRY", "UAH", "USD"],
      currencies: [],

      fromAirportsItems: ["Anapa,Rusya / AAQ", "Abakan,Rusya / ABA"],
      fromAirports: [],

      toAirportsItems: [
        "Antalya,Turkey (AYT-Antalya Int) / AYT",
        "Akabe,Urdun / AQJ",
      ],
      toAirports: [],

      flightItems: ["AAQ - ABA", "MOW - AYT"],
      flights: [],

      flightClassItems: ["Economy"],
      flightClasses: [],

      flightSegmentItems: ["Y"],
      flightSegments: [],

      passengerTypeItems: ["Yetişkin", "Çocuk", "Bebek"],
      passengerTypes: [],

      salesChannelItems: ["Acente", "İnternet", "Momondo", "Skyscanner"],
      salesChannels: [],

      methodItems: [
        "1 - Sefer Tutar Kuralı",
        "2 - Gidiş Uçuş Kuralı",
        "3 - Sefer Fiyat Kuralı",
      ],
      methods: [],

      calculationTypeItems: ["Oran", "Miktar"],
      calculationTypes: [],

      typeOfChangeItems: ["İndirim", "Zam"],
      typeOfChanges: [],
    };
  }
}
